namespace('arctic.views.group');

compass.require('compass.hotel.StayRecapWidget');
compass.require('compass.hotel.PoliciesWidget');
compass.require('compass.hotel.CancelRoomWidget');


compass.require('compass.group.GroupFormsWidget');

compass.require('compass.util.validate');

arctic.views.group.groupPaymentRequired = function (viewport,options) {
	var _viewport = viewport;
	var $j = jQuery;

	var _settings = options;
	var _data;
	var _validator = new compass.validator({
		widget: me,
		onValid: function (field, opts) {
			field.removeClass("invalid");
			_checkWholeForm();
		},
		onInvalid: function (field, opts) {
			field.addClass("invalid");
		}
	});

	var _str2date = function (src) {
		src = src.split("-");
		return new Date(parseInt(src[0], 10), parseInt(src[1], 10),
				parseInt(src[2], 10), 0, 0, 0, 0);
	};

	var groupInfo;
	var _jsonData;
	var _groupFormsWidget, _stayRecapWidget;

	var me = this;
	var _meeting;
	var _details;
	var _hotel;

	var render = function (d) {
		_viewport.append(d.div({ className : 'groupPaymentRequired' },
			d.div({ className : 'reservationRecap' }),
			d.div({ className : 'separator'}),
			d.div({ className: 'groupFormsContainer' }),
			d.div({ className : 'stayRecap' })
		));
	};

	var _showPoliciesPopup = function(data, stayRecapData) {
		jQuery.ajax({
			data: {
				blocked_room_id: stayRecapData.blockedRoomId
			},
			dataType:'json',
			traditional: true,
			url:'/policies',
			success : function(data) {
				var d = jQuery.dom;
				var policiesDiv = d.div({className:'policiesContainer'});

				_policiesWidget = new compass.hotel.PoliciesWidget(policiesDiv,
					{
						WUID : 'policiesWidget_individualPersonalInfo',
						policies: data
					});

				_policiesDialog = d.dialog({
					classes: 'personalInfo policiesDialog',
					contents: policiesDiv,
					centerOnView: true
				});
			}
		});
	};

	var _handleCancel = function (event, data) {
		var d = jQuery.dom;
		var cancelDialogId = data.dialogId || '';
		var container = d.div();
		var cancelValidator = new compass.validator({
					onValid : function (e) { e.removeClass('invalid'); },
					onInvalid: function (e) { e.addClass('invalid'); }
				});
		var cancelWidget = new compass.hotel.CancelRoomWidget(container, {
									cancelFee : 0,
									currencyFormatter : _settings.meetingInfo.defaultCurrencyFormatter,
									validator: cancelValidator,
									cancelReasons : _data.cancelReasons
								});

		var cancelButton = cancelWidget.getCancelButton();
		var checkbox = cancelWidget.getCheckbox();
		checkbox.addClass('disabled');

		cancelWidget.bind('CancelRoomWidget.cancelFeeCheckboxChanged', function(event) {
			if (checkbox.length > 0 && checkbox.is(":checked")) {
				checkbox.removeClass('invalid');
				cancelButton.removeClass('disabled');
			} else if (checkbox.length > 0) {
				checkbox.addClass('invalid');
				cancelButton.addClass('disabled');
			} else {
				return;
			}
		});

		cancelWidget.bind('CancelRoomWidget.cancelReasonsChanged', function(event, values) {
			var values = cancelWidget.getValues();
			if (values.reason >= 0 && (checkbox.is(":checked") || checkbox.length === 0)) {
				cancelButton.removeClass('disabled');
			}
		});

		cancelWidget.bind('CancelRoomWidget.Cancel', function (event, data) {

			var fields = cancelValidator.validate();
			if (fields.length > 0) {
				return;
			}

			jQuery.ajax({
				url: '/actCancel',
				type: 'POST',
				data: data,
				success: function(data) {
					cancelDialog.close();
					jQuery.ajax({
						url : '/sendConfirmation',
						success : function(data) {
							_viewport.trigger(CompassEvents.Navigate, 'frontDesk');
						}
					});
				}
			});
		});

		var cancelDialog = d.dialog({
			contents: container,
			classes: "individualFrontDesk CancelDialog",
			showParent: true,
			idGenerator: compass.generateId,
			dialogId: cancelDialogId
		});
	};

	
	
	var _invalid_fields = [];

	var onFormSubmit = function(formData, finishLoading) {
		var paymentRequiredData = {
			payment_info: formData.payment,
			policiesCheckbox: _viewport.find('.policiesCheckbox').prop('checked')
		};

		$j.ajax({
			url: '/actPaymentRequired',
			data : JSON.stringify(paymentRequiredData),
			type : 'POST',
			contentType : 'application/json',
			processData: false,
			success: function (data) {
				// TODO: should we send confo?
				if (data.success === false) {
					if (data.policiesCheckboxChecked === false) {
						d.alert("Please agree to the hotel policies before continuing.");
					} else {
						alert ('Problem creating record.');
					}
				} else {
					$j('body').css({cursor : 'inherit'});
					$j('body').trigger(CompassEvents.Login, data.loginInfo);
					$j('.forms').trigger(CompassEvents.Navigate, 'groupManage');
					finishLoading();
				}
			}
		});
	};

	var setup = function (data) {
		var d = jQuery.dom;
		_jsonData = data;
		meeting = data.meeting;
		_hotel = data.hotel;
		
		var reservationArray = _.pluck(data.recapArray, 'stayRecap');

		var recaps = _.filter(reservationArray, function(e,i){
																return e.depositWillBeCharged;
							   });
		var	chargingInfo = {
				hasCharging : _.some(reservationArray, function(r){return (r.depositWillBeCharged);}),
				chargingToday : _.some(reservationArray, function(r){
																		return (r.depositWillBeCharged && r.depositWillBeChargedTodayOrEarlier);
																	}),
			    chargingFirstDate : recaps.length > 0 ? compass.util.parse.ISODateParser(_.min(recaps,function(e){ return Number(e.depositWillBeChargedAt.split('-').join(''));}).depositWillBeChargedAt) : ''
		};


		var _groupFormsWidget = new compass.group.GroupFormsWidget(_viewport.find('.groupFormsContainer'), {
			blockRoomId: data.blockRoomId,
			countriesAndStates: _settings.countriesAndStates,
			extraRequiredFields: data.extraRequiredFields,
			groupInfo: data.groupInfo,
			paymentOptions: data.paymentInfo,
			reservations: data.reservations,
			validator: _validator,
			meetingInfo: _settings.meetingInfo,
			onFormSubmit: onFormSubmit,
			chargingInfo: chargingInfo,
			drawPoliciesLink: false,
			paymentRequired: true
		});

		var _stayRecapWidget = new compass.hotel.StayRecapWidget(_viewport.find('.stayRecap'), {
			recapArray : data.recapArray,
			validator: _validator,
			meetingInfo: _settings.meetingInfo,
			groupInfo: groupInfo,
			chargingInfo: _settings.chargingInfo
		});

		_stayRecapWidget.bind('StayRecapWidget.showPolicies', function (e, stayRecapData) {
			compass.GA.trackEvent('Hotel Policies', 'View Policies', 'Group Info - Receipt');
			_showPoliciesPopup(data, stayRecapData);
		});

		_viewport.find(".stayRecap").append(d.div({className : 'stayRecapShadow'}));

		var cancelRoomsDialogId = compass.generateId();
		_groupFormsWidget.find(".cancelReservations").bind('click', function(evt){_handleCancel(evt, {dialogId: cancelRoomsDialogId})});
		
		
		_viewport.find('.policiesCheckbox').change(function() {
			if ($(this).is(':checked')) {
				$('.alertCloseButton').activate();
			}
		});
	};

	var _checkWholeForm = function() {
		_validation_res = _validator.validate();

		if (_validation_res.length === 0) {
			var button = _viewport.find(".saveButton");
			button.removeClass('disabled');
		}
	};

	this.run = function (renderComplete) {
		compass.loading.start();

		$j.ajax({
			url : '/paymentRequired',
			success: function (data) {
				_settings.countriesAndStates = data.countriesAndStates;
				_settings.chargingInfo = data.chargingInfo;
				_data = data;
				if(data.groupInfo)groupInfo = data.groupInfo;

				if (data.error) {
					_viewport.trigger(CompassEvents.Navigate, 'groupManage');
				} else {
					render(jQuery.dom);
					setup(data);
				}
				compass.loading.stop();
				renderComplete();
			}
		});
	};

};
